import { render, staticRenderFns } from "./page-PaiDan-view.vue?vue&type=template&id=1575bf0e&scoped=true&"
import script from "./page-PaiDan-view.vue?vue&type=script&lang=js&"
export * from "./page-PaiDan-view.vue?vue&type=script&lang=js&"
import style0 from "./page-PaiDan-view.vue?vue&type=style&index=0&id=1575bf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575bf0e",
  null
  
)

component.options.__file = "page-PaiDan-view.vue"
export default component.exports